import React, { useState, useEffect } from "react";

export const svg = `<svg width="48" height="48" viewbox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.781 32.79c-4.198-6.489-.815-12.509 1.371-14.536-8.157-2.052-13-7.986-14.371-10.869-.525 8.635 5.585 15.406 8.706 17.712-1.297.238-2.325-.457-2.802-.895.143 4.485 4.79 10.178 7.096 12.464v-3.877Zm15.564-6.411a7.126 7.126 0 1 1-14.252 0 7.126 7.126 0 0 1 14.252 0Zm-.508-8.125c2.186 2.027 5.57 8.047 1.372 14.535v3.877c2.305-2.286 6.953-7.98 7.096-12.464-.477.438-1.506 1.133-2.803.895 3.121-2.306 9.231-9.077 8.707-17.711-1.372 2.882-6.214 8.816-14.372 10.868Z" fill="#51484A"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
